import React, { useEffect } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { DocumentPage, usePageData } from '@seo-hub/site-kit/react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NotFoundPage from './NotFoundPage';
import { blogData } from '../mock/blogData';

const legacyGuides = new Set(blogData.articles.map((a) => `/blog/${a.slug}`));

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute(attr, value);
};

// Pages published by SEO Hub. The server already sent full HTML and meta for
// the first load; this keeps head tags right on client-side navigation.
const HubDocumentPage = () => {
  const { pathname } = useLocation();
  const { doc, loading, notFound, error } = usePageData(pathname);

  useEffect(() => {
    if (!doc) return;
    document.title = `${doc.title} | IP9`;
    setMeta('meta[name="description"]', 'content', doc.metaDescription || doc.excerpt);
    setMeta('link[rel="canonical"]', 'href', doc.canonical || `${window.location.origin}${doc.path}`);
    setMeta('meta[name="robots"]', 'content', doc.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large');
  }, [doc]);

  if (notFound && legacyGuides.has(pathname)) return <Navigate to={pathname.replace(/^\/blog\//, '/integrations/')} replace />;
  if (notFound || error) return <NotFoundPage />;

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main className="relative border-b border-slate-800">
        <div className="absolute inset-x-0 top-0 h-80 bg-grid bg-grid-fade pointer-events-none" />
        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
          {loading ? (
            <div className="space-y-4" aria-busy="true">
              <div className="skeleton h-4 w-40" />
              <div className="skeleton h-12 w-3/4" />
              <div className="skeleton h-4 w-full" />
              <div className="skeleton h-4 w-5/6" />
            </div>
          ) : (
            <DocumentPage doc={doc} Link={Link} />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HubDocumentPage;
